const services = [
  {
    number: '01',
    icon: 'ri-lightbulb-line',
    title: 'プロデュース',
    desc: '物件のコンセプト設計から集客戦略まで',
    href: '#produce',
  },
  {
    number: '02',
    icon: 'ri-file-list-3-line',
    title: '民泊申請代行',
    desc: '民泊新法に基づく届出・許可申請を代行',
    href: '#minpaku',
  },
  {
    number: '03',
    icon: 'ri-building-2-line',
    title: '簡易宿所申請代行',
    desc: '旅館業法に基づく簡易宿所の許可申請',
    href: '#kantan',
  },
  {
    number: '04',
    icon: 'ri-key-2-line',
    title: '民泊貸別荘の管理業務',
    desc: '予約管理・清掃・ゲスト対応まで一括管理',
    href: '#kanri',
  },
  {
    number: '05',
    icon: 'ri-hammer-line',
    title: '建物リフォーム事業',
    desc: '価値を高めるリノベーション・内装工事',
    href: '#reform',
  },
  {
    number: '06',
    icon: 'ri-home-heart-line',
    title: '貸別荘の運営',
    desc: '特別な滞在体験を生み出す貸別荘の企画・運営',
    href: '#kashisouvilla',
  },
];

export default function ServicesOverview() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="w-full bg-white py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-amber-600 text-xs tracking-[0.5em] uppercase mb-3">Services</p>
          <h2 className="text-stone-900 text-3xl lg:text-4xl font-light mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            サービス一覧
          </h2>
          <div className="w-12 h-px bg-amber-500 mx-auto" />
        </div>

        {/* 6 Cards Horizontal */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {services.map((service) => (
            <button
              key={service.number}
              onClick={() => handleScroll(service.href)}
              className="group text-left p-5 rounded-lg border border-stone-200 hover:border-amber-400 hover:bg-amber-50 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-amber-500 text-xs font-medium tracking-widest">{service.number}</span>
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${service.icon} text-xl text-stone-400 group-hover:text-amber-600 transition-colors duration-300`} />
                </div>
              </div>
              <h3 className="text-stone-800 text-xs font-semibold mb-2 leading-tight whitespace-normal" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                {service.title}
              </h3>
              <p className="text-stone-500 text-xs leading-relaxed whitespace-normal">{service.desc}</p>
              <div className="mt-3 flex items-center text-amber-600 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>詳細</span>
                <div className="w-4 h-4 flex items-center justify-center ml-1">
                  <i className="ri-arrow-right-line text-xs" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
